<template>
  <div v-if="!mobileCheck()" class="Footer" >
    <div class="Container">
      <div class="Footer-left">
        <img src="../../assets/vsystems_logo.svg"/>
        <p>© {{ currentYear }} v.systems All rights reserved</p>
      </div>
      <div class="Footer-right">
        <div style="width: 410px;text-align: left;">The information listed here may change according to the Supernodes' activities and rates. Please double-check this information on your VSYS wallet.</div>
        <div style="text-align: left;">Interested in becoming a Supernode? Please
          <a class="link" target="_blank" style="text-decoration: underline;"
             href="https://goo.gl/forms/CVFsD4RpcaGreZtE2">apply here</a>
        </div>
        <div class="social">
          <a href="https://github.com/virtualeconomy/v-systems" target="_blank" class="link">
            <img src="../../assets/ic_github.svg"/>
          </a>

          <a href="https://twitter.com/VSYSCoin" target="_blank" class="link">
            <img src="../../assets/ic_twitter.svg"/>
          </a>

          <a href="https://www.reddit.com/r/V_SYSTEMS" target="_blank" class="link">
            <img src="../../assets/ic_reddit.svg"/>
          </a>

          <a href="https://medium.com/vsystems" target="_blank" class="link">
            <img src="../../assets/ic_medium.svg"/>
          </a>

          <!-- <a href="https://www.facebook.com/vsystemsofficial" target="_blank" class="link">
            <img src="../../assets/ic_facebook.svg"/>
          </a> -->

          <a href="https://www.youtube.com/channel/UC3tnJX2dztNKh2yJxFVSDAw" target="_blank" class="link">
            <img src="../../assets/ic_youtube.svg"/>
          </a>

          <a href="https://t.me/VSYSOfficialGroup" target="_blank" class="link">
            <img src="../../assets/ic_telegram.svg"/>
          </a>

          <a href="https://bitcointalk.org/index.php?topic=5095853.0" target="_blank" class="link">
            <img src="../../assets/ic_bitcointalk.svg"/>
          </a>

          <!-- <a href="https://open.kakao.com/o/gVkyQVrb" target="_blank" class="link">
            <img class="kakaoicon" src="../../assets/ic_kakao.png"/>
          </a> -->
        </div>
      </div>
    </div>
  </div>
  <div v-else class="footer">
    <img class="footer-logo" src="../../assets/vsystems_logo.svg"/>
    <div class="footer-content" style="text-align: left;">
      The information listed here may change according to the Supernodes' activities and rates. Please double-check this information on your VSYS wallet.
      Interested in becoming a Supernode?
        Please
      <a  style="text-decoration: underline;" href="https://goo.gl/forms/CVFsD4RpcaGreZtE2">apply here</a>
    </div>
    <div class="linkCon">
      <a href="https://github.com/virtualeconomy/v-systems" target="_blank" class="link">
        <img src="../../assets/ic_github.svg"/>
      </a>

      <a href="https://twitter.com/VSYSCoin" target="_blank" class="link">
        <img src="../../assets/ic_twitter.svg"/>
      </a>

      <a href="https://www.reddit.com/r/V_SYSTEMS" target="_blank" class="link">
        <img src="../../assets/ic_reddit.svg"/>
      </a>

      <a href="https://medium.com/vsyscoin" target="_blank" class="link">
        <img src="../../assets/ic_medium.svg"/>
      </a>

      <!-- <a href="https://www.facebook.com/vsystemsofficial" target="_blank" class="link">
        <img src="../../assets/ic_facebook.svg"/>
      </a> -->

      <a href="https://www.youtube.com/channel/UC3tnJX2dztNKh2yJxFVSDAw" target="_blank" class="link">
        <img src="../../assets/ic_youtube.svg"/>
      </a>

      <a href="https://t.me/VSYSOfficialGroup" target="_blank" class="link">
        <img src="../../assets/ic_telegram.svg"/>
      </a>

      <a href="https://bitcointalk.org/index.php?topic=5095853.0" target="_blank" class="link">
        <img src="../../assets/ic_bitcointalk.svg"/>
      </a>

      <!-- <a href="https://open.kakao.com/o/gVkyQVrb" target="_blank" class="link">
        <img class="kakao" src="../../assets/ic_kakao.png"/>
      </a> -->
    </div>
    <div class="footer-right">
      © {{ currentYear }} v.systems All rights reserved
    </div>
  </div>
</template>

<script>
  import { mobileCheck } from '@/utils/common';

  export default {
    name: 'Footer',
    computed: {
      currentYear() {
        return new Date().getFullYear();
      },
    },
    methods: {
      mobileCheck() {
        return mobileCheck();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .Footer {
    background: #F7F7FA;
    padding-top: 40px;
    padding-bottom: 200px;
    line-height: 2;
    color: #7D7D80;
    font-size: 14px;
    height: 188px;
    box-sizing: border-box;
    min-width: 1240px;
    .Container{
      display: flex;
      justify-content: space-between;
    }
    &-left {
      img {
        margin-bottom: 8px;
      }
    }
    &-right {
      text-align: right;
    }
  }

  .title {
    font-weight: 700;
    color: #101010;
  }

  .link {
    color: #FF8737;
  }
  .kakaoicon{
    width:24px;
  }
  .social {
    display: flex;
    align-items: center;
    margin-top: 30px;
    .link + .link {
      margin-left: 28px;
    }
  }

  .footer{
    width: 3.75rem;
    height: 2.87rem;
    background: #F7F7FA;
    color: #7D7D80;
    overflow: hidden;
    margin: 0 auto;
    &-logo{
      height: 0.22rem;
      width: 1.24rem;
      display: block;
      margin: 0 auto;
      margin-top: 0.2rem;
    }
    &-content{
      font-size: 13px;
      width: 2.9rem;
      margin: 0 auto;
      line-height: 1.5em;
      text-align: center;
      margin-top: 0.15rem;
      a{
        color: #FF8837;
      }
    }
    &-right{
      font-size: 12px;
      width: 3.45rem;
      margin: 0 auto;
      border-top: 1px solid #EDEDF2;
      height: 0.44rem;
      line-height: 0.44rem;
      text-align: center;
      margin-top: 0.1rem;
    }

    .linkCon{
      display: flex;
      flex-wrap: wrap;
      width: 2.8rem;
      justify-content: center;
      margin: 0 auto;
      margin-top: 0.3rem;
      .kakao{
        height: 22px;
      }
      a{
        margin-right: 0.18rem;
        margin-left: 0.18rem;
        margin-bottom: 0.2rem;
        height: 0.2rem;
        img{
          display: block;
        }
      }
    }
  }
</style>
